<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onRowItemClick">
            <template v-slot:[`item.date`]="{ item }">
                <span>
                    {{ $util.getDDMMYYYYDateFormat(new Date(item.date).getTime() + (60*420*1000)) }}
                </span>

                <span class="grey--text">
                    {{ $util.getHHSSDateFormat(new Date(item.date).getTime() + (60*420*1000)) }}
                </span>
            </template>

            <template v-slot:[`item.value`]="{ item }">
                <span
                    :class="{
                        'activeStatus--text': item.value >= 0,
                        'error--text': item.value < 0
                    }">
                    {{ item.amount }}
                </span>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import { TableMixinFactory } from '@/mixins/TableMixin'

export default {
    name: 'TransactionTable',

    components: {
        BaseTable
    },

    mixins: [
        TableMixinFactory({
            itemMapFunc: function (item) {
                return {
                    ...item,
                    amount: item.value < 0 ? item.value : `+${item.value}`
                }
            }
        })
    ],

    data () {
        return {
            headers: [
                {
                    text: this.$t('andamandaPay.transactionTable.header.refNo'),
                    value: 'name'
                },
                {
                    text: this.$t('andamandaPay.transactionTable.header.date'),
                    value: 'date'
                },
                // {
                //     text: this.$t('andamandaPay.transactionTable.header.detail'),
                //     value: this.$constant.table.TRANSACTION_HEADER_KEY.detail
                // },
                {
                    text: this.$t('andamandaPay.transactionTable.header.amount'),
                    value: 'value',
                    align: 'right'
                }
            ]
        }
    },

    methods: {
        onRowItemClick (item) {
            this.$emit('viewDetails', item)
        }
    }
}
</script>

<style lang="scss" scoped></style>
